import React, { Component, Fragment } from "react";
import AuthenticationService from "../Services/AuthenticationService";

class LoginCache extends Component {
  constructor(props) {
    super(props);
    let pathname = props.location.pathname;
    let search = props.location.search;
    
    if ( !props.user 
      && pathname !== "/wcpp/login" 
      && pathname !== "/wcpp/authenticate"
      && pathname !== "/wcpp/confirmPasswordReset"
      && pathname !== "/wcpp/confirmAddUser"
      && pathname !== "/wcpp/requestAccount" ) {
      AuthenticationService.setInitialUrl(pathname+search);
    } 
  }
   
  render() {
    return <Fragment />;
  }
}

export default LoginCache;
